import {SeverityLevel } from '../types/API'
import { useInfiniteQuery } from '@tanstack/react-query'
import useLoggedUser from './useLoggedUser'
import { useApi } from './useApi'

export type EnvironmentNotificationsParams = {
  mimicId: number
  startDate?: Date
  endDate?: Date
  severity?: SeverityLevel
  limit?: number
  page?: number
}

export type EnvironmentNotificationsResponse = {
  _id: string
  notificationId: string
  title: string
  details: string
  severity: SeverityLevel
  createdAt: string
}

function useEnvironmentNotifications(params: Omit<EnvironmentNotificationsParams, 'page'> = {}) {
  const { callApi } = useApi()
  const { data: me } = useLoggedUser()

  const fetchNotifications = async ({ pageParam = 1 }): Promise<EnvironmentNotificationResponse[]> => {
    const response = await callApi<EnvironmentNotificationResponse[]>('/notifications/environment', { mimicId: params.mimicId })
    return response || []
  }

  const { data, isLoading, isError } = useInfiniteQuery({
    queryKey: ['adminNotifications', ...Object.entries(params)],
    queryFn: fetchNotifications,
    getNextPageParam: (lastPage, allPages) => {
      return lastPage?.length === params.limit ? allPages.length + 1 : undefined
    },
    initialPageParam: 1,
    staleTime: 1000,
    enabled: !!me,
  })

  return {
    notifications: data?.pages.flat() || [],
    isLoading,
    isError,
  }
}

export default useEnvironmentNotifications
